module.exports = __webpack_public_path__ + "37643a1ef8f8da7e7e9f288ce4feac39.png";